
<script>
// import {load, Map, Marker} from 'vue-google-maps'

export default {
  computed: {
    student_tutor () {
      return this.$store.getters.student_tutor
    }
  },
  // components: {
  //   'google-map': Map,
  //   'marker': Marker
  // },
  data () {
    return {
      zoom: 7,
      center: {lat: 38.255021, lng: 140.881407},
      markers: [
        {
          position: {lat: 38.255021, lng: 140.881407}
        }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getStudent_tutor(to.params.id)
      vm.getTags(to.params.id)
    })
  },
  methods: {
    getStudent_tutor (id) {
      this.$store.dispatch('getStudent_tutor', id)
    },

    getTags () {
      this.$store.dispatch('getTags')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Student_tutor.vue?7ad48514